import { useState } from 'react'
import CatalogTransferTabStore from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-tab-store'
import useSearchCriteriaUrlSync from '@Components/Search/SearchPanel/useSearchCriteriaUrlSync'

/**
 * The search terms' side of the table's URL sync, the sibling of `useCatalogTransferFilters`. Both write the one
 * query string through the shared URL writer, so keep them wired side by side. Review tab only (?transferId=…):
 * the store is seeded before the first render — the form picks its rows up then — and marked stale so the mount's
 * refresh runs the linked search.
 */
export const useCatalogTransferSearchTerms = (
    catalogTransferTabStore: CatalogTransferTabStore,
    isReviewTab: boolean | undefined
) => {
    const { urlCriteria, syncCriteriaToUrl } = useSearchCriteriaUrlSync(
        catalogTransferTabStore.criteriaStore.criteriaOptions
    )
    useState(() => {
        if (isReviewTab && urlCriteria) {
            catalogTransferTabStore.seedSearchFromUrl(urlCriteria)
        }
    })

    return { syncCriteriaToUrl }
}
